<div class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">
              <span *ngIf="!editar_nombre" class="px-20">{{consolidacion?.nombre}}</span>
              <input placeholder="Nombre" matInput [(ngModel)]="nombre" *ngIf="editar_nombre">
              <mat-icon *ngIf="editar_nombre" aria-hidden="false" aria-label="Editar estado" (click)="updateName(nombre)" >save</mat-icon>
              <!--<a *ngIf="is_owner && consolidacion?.estado!='CERRADO'" (click)="editar_nombre=true">Editar</a>-->
              <mat-icon *ngIf="is_eval_creador" aria-hidden="false" aria-label="Editar nombre" (click)="editar_nombre=true" >edit</mat-icon>
            </h2>

        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

          <div class="toolbar px-24 py-8">

              <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                <button  mat-button (click)="print()" mat-flat-button color="primary" class="add-row">
                  <mat-icon  aria-hidden="false" aria-label="print" >print</mat-icon>
                </button>
              </div>
              <button  mat-button (click)="navegateTo('mis-evaluaciones-consolidadas')" mat-flat-button color="primary" class="add-row">
                <mat-icon  aria-hidden="false" aria-label="Salir" >exit_to_app</mat-icon>
                Salir
              </button>

          </div>

            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" style="max-height: 200px !important;"  >

                <div id="scan" class="p-24" fxLayout="row" xFlex="100">

                    <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">

                        <div class="profile-box info-box general" fxLayout="column">

                          <table class="summary">

                              <tr class="code">
                                  <td class="label">Escenario</td>
                                  <td class="value">
                                    <span  class="px-20">{{consolidacion?.escenario?.nombre}}</span>
                                  </td>
                              </tr>

                              <tr class="code">
                                  <td class="label">Factor de ponderación</td>
                                  <td class="value">
                                    <span  class="px-20">{{consolidacion?.factorPonderacion?.nombre}}</span>
                                  </td>
                              </tr>

                              <tr class="code">
                                  <td class="label">Tipo de ponderación</td>
                                  <td class="value">
                                    <span class="px-20">{{consolidacion?.tipo}}</span>

                                  </td>
                              </tr>

                              <tr>
                                  <td class="label">Estructura jerárquica / Nodo</td>
                                  <td class="value">
                                    <span class="px-20" >{{consolidacion?.estructuraJerarquica?.nombre}} / {{consolidacion?.nodoEstructuraJerarquica?.nombre}}</span>

                                  </td>
                              </tr>
                          </table>
                        </div>
                    </div>


                    <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="50">
                      <div class="profile-box info-box general" fxLayout="column">
                        <table class="summary">
                            <tr class="code">
                                <td class="label">Responsable</td>
                                <td class="value">
                                  <span  class="px-20">{{consolidacion?.responsable?.nombreCompleto}}</span>
                                </td>
                            </tr>

                            <tr>
                                <td class="label">Fecha inicio</td>
                                <td class="value">
                                  <span  class="px-20">{{consolidacion?.fechaInicio | date:'dd/MM/yyyy'}}</span>

                                </td>
                            </tr>

                            <tr>
                                <td class="label">Fecha finalización</td>
                                <td class="value">
                                  <span class="px-20">{{consolidacion?.fechaFin | date:'dd/MM/yyyy'}}</span>

                                </td>
                            </tr>
                            <tr>
                                <td class="label">Creado por</td>
                                <td class="value"><span class="px-20">{{consolidacion?.creador?.nombreCompleto}}</span></td>
                            </tr>

                        </table>
                    </div>
                </div>
              </div>
            </div>
            <!-- / CONTENT -->


            <!-- TABS -->

            <div class="content" >

                <mat-tab-group dynamicHeight (selectedTabChange)="tabChanged($event)">

                    <mat-tab label="Objetivos">

                        <div class="widget-group p-12" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                             <div class="content p-24">

                                 <table mat-table [dataSource]="consolidacion?.objetivos" #mytable class="my-table mat-elevation-z8">

                                   <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                   <!-- User Column -->
                                   <ng-container matColumnDef="nombre">
                                     <th mat-header-cell *matHeaderCellDef> Nombre. </th>
                                     <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                                   </ng-container>

                                   <!-- Role Column -->
                                   <ng-container matColumnDef="descripcion">
                                     <th mat-header-cell *matHeaderCellDef> Descripcion. </th>
                                     <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                                   </ng-container>

                                   <tr mat-header-row *matHeaderRowDef="displayedColumnsObjetivos"></tr>
                                   <tr mat-row *matRowDef="let row; columns: displayedColumnsObjetivos;"></tr>
                                 </table>

                             </div>


                        </div>
                        <!-- / WIDGET GROUP -->

                    </mat-tab>

                    <mat-tab label="Analistas">

                        <!-- WIDGET GROUP -->
                        <div class="widget-group" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                             <div class="content p-24">

                                 <table mat-table [dataSource]="consolidacion?.usuarios" #mytable class="my-table mat-elevation-z8">

                                   <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                   <!-- User Column -->
                                   <ng-container matColumnDef="nombre">
                                     <th mat-header-cell *matHeaderCellDef> Nombre. </th>
                                     <td mat-cell *matCellDef="let element"> {{element.nombreCompleto}} </td>
                                   </ng-container>

                                   <!-- Role Column -->
                                   <ng-container matColumnDef="correoElectronico">
                                     <th mat-header-cell *matHeaderCellDef> Usuario. </th>
                                     <td mat-cell *matCellDef="let element"> {{element.correoElectronico}} </td>
                                   </ng-container>

                                   <tr mat-header-row *matHeaderRowDef="displayedColumnsUsuarios"></tr>
                                   <tr mat-row *matRowDef="let row; columns: displayedColumnsUsuarios;"></tr>
                                 </table>

                             </div>

                        </div>
                        <!-- / WIDGET GROUP -->

                    </mat-tab>

                    <!-- <mat-tab label="Dimensiones">

                        <div class="widget-group" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                             <div class="content p-24">

                                 <table mat-table [dataSource]="consolidacion?.dimensiones" #mytable class="my-table mat-elevation-z8">

                                   <ng-container matColumnDef="nombre">
                                     <th mat-header-cell *matHeaderCellDef> Nombre </th>
                                     <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="descripcion">
                                     <th mat-header-cell *matHeaderCellDef> Descripción </th>
                                     <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="categorias">
                                     <th mat-header-cell *matHeaderCellDef> Categorias </th>
                                     <td mat-cell *matCellDef="let element">
                                       <mat-chip-list aria-label="Categorias">
                                         <mat-chip *ngFor="let categoria of element.categorias">{{categoria}}</mat-chip>
                                       </mat-chip-list>
                                     </td>
                                   </ng-container>

                                   <tr mat-header-row *matHeaderRowDef="displayedColumnsDimensiones"></tr>
                                   <tr mat-row *matRowDef="let row; columns: displayedColumnsDimensiones;"></tr>
                                 </table>

                             </div>

                        </div>
                    </mat-tab> -->

                    <mat-tab label="Análisis Residual" fxLayout="column wrap" >

                      <div class="widget-group" fxLayout="column" fxFlex="100" *fuseIfOnDom>
                        <div class="content p-24" >
                          <div fxFlex="50" class="content p-24"><span>Formula de exposición</span> | {{consolidacion?.escenario?.formulaDeExposicion}}</div>
                          <div fxFlex="20" class="content p-24"><span>Apetito</span> | {{consolidacion?.escenario?.apetito}}</div>
                          <div fxFlex="20" class="content p-24"><span>Tolerancia</span> | {{consolidacion?.escenario?.tolerancia}}</div>
                        </div>
                        
                        <!-- WIDGET GROUP -->
                        <div class="content p-24">
                              <table mat-table [dataSource]="riesgos" #mytable class="my-table mat-elevation-z8">

                                <ng-container matColumnDef="evaluacion">
                                  <th mat-header-cell *matHeaderCellDef> Evaluaciones </th>
                                  <td mat-cell *matCellDef="let element"> {{element.evaluacion?.nombre}} </td>
                                </ng-container>


                                <ng-container matColumnDef="objetivo">
                                  <th mat-header-cell *matHeaderCellDef> Objetivo </th>
                                  <td mat-cell *matCellDef="let element"> {{element.objetivo?.nombre}} </td>
                                </ng-container>

                                <ng-container matColumnDef="riesgo">
                                  <th mat-header-cell *matHeaderCellDef> Riesgo </th>
                                  <td mat-cell *matCellDef="let element"> {{element.riesgo?.nombre}} </td>
                                </ng-container>

                                <!--
                                <ng-container matColumnDef="control">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Control instalado </th>
                                  <td mat-cell *matCellDef="let element"> {{element.topAnalisisResidual?.control}}</td>
                                </ng-container>
                                -->

                                <ng-container matColumnDef="probabilidad">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Probabilidad </th>
                                  <td mat-cell *matCellDef="let element">
                                    <span matTooltip="{{element.topAnalisisResidual?.probabilidad?.nombre}}"
                                    matTooltipPosition="right">{{element.topAnalisisResidual?.probabilidad?.valor | number:'1.2-2'}}
                                    </span>
                                  </td>
                                </ng-container>

                                <ng-container matColumnDef="impacto">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Impacto </th>
                                  <td mat-cell *matCellDef="let element">
                                    <span matTooltip="{{element.topAnalisisResidual?.impacto?.nombre}}"
                                    matTooltipPosition="right">{{element.topAnalisisResidual?.impacto?.valor | number:'1.2-2'}}
                                    </span>
                                  </td>
                                </ng-container>

                                <ng-container matColumnDef="factor">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Factor de ponderación</th>
                                  <td mat-cell *matCellDef="let element"> {{element.factor?.factor | number:'1.2-2'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="impactoPonderado">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Impacto Ponderado</th>
                                  <td mat-cell *matCellDef="let element"> {{element.impactoPonderado | number:'1.2-2'}} </td>
                                </ng-container>


                                <ng-container matColumnDef="exposicion">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Exposición residual</th>
                                  <td mat-cell *matCellDef="let element"> {{element.topAnalisisResidual?.exposicion | number:'1.2-2'}} </td>
                                </ng-container>


                                <ng-container matColumnDef="clasificacion">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Clasificación</th>
                                  <td mat-cell *matCellDef="let element">
                                    <div [ngClass]="{'success' : element.topAnalisisResidual?.clasificacion=='Aceptable',  'error' : element.topAnalisisResidual?.clasificacion=='Inaceptable', 'warning' : element.topAnalisisResidual?.clasificacion=='Atención'}">{{element.topAnalisisResidual?.clasificacion}}</div> </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsAnalisisResidual"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsAnalisisResidual;"></tr>
                              </table>
                        </div>
                        <div class="content p-24">
                          <mat-card class="example-card">
                            <mat-card-header>
                              <mat-card-title>Mapa de calor</mat-card-title>

                            </mat-card-header>

                            <mat-card-content fxLayout="row">
                                <ngx-charts-heat-map
                                    [view]="view"
                                    [scheme]="colorScheme"
                                    [legend]="false"
                                    [gradient] = "gradient"
                                    [showXAxisLabel]="showXAxisLabel"
                                    [showYAxisLabel]="showYAxisLabel"
                                    [xAxis]="xAxis"
                                    [yAxis]="yAxis"
                                    [xAxisLabel]="xAxisLabel"
                                    [yAxisLabel]="yAxisLabel"
                                    [maxXAxisTickLength]="50"
                                    [trimXAxisTicks]="true"
                                    [maxYAxisTickLength]="50"
                                    [trimYAxisTicks]="true"
                                    [results]="multi"
                                    [customColors]="customColors"
                                    [tooltipDisabled]=false


                                    >
                                    <ng-template #tooltipTemplate let-model="model"
                                    >
                                        <div [innerHTML]="tooltipText(model)" style="
                                          font-size: 16px;
                                          padding: 8px !important;"></div>
                                    </ng-template>

                                  </ngx-charts-heat-map>
                            </mat-card-content>

                          </mat-card>
                        </div>

                        <div class="content p-24">
                          <mat-card class="example-card">
                            <mat-card-header>
                              <mat-card-title>En porcentajes</mat-card-title>

                            </mat-card-header>

                            <mat-card-content fxLayout="row">
                                  <ngx-charts-pie-grid
                                    [view]="view"
                                    fxFlex="100"
                                    [scheme]="colorScheme"
                                    [customColors]="customColorsPie"
                                    [results]="pieDataExposiciones"
                                    >
                                  </ngx-charts-pie-grid>
                              
                            </mat-card-content>

                          </mat-card>
                        </div>

                        </div>
                        <!-- / WIDGET GROUP -->

                    </mat-tab>

                    <mat-tab label="Evaluaciones origen">

                        <!-- WIDGET GROUP -->
                        <div class="widget-group" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom>

                             <div class="content p-24">

                                 <table mat-table [dataSource]="consolidacion?.evaluaciones" #mytable class="my-table mat-elevation-z8">

                                   <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                   <!-- User Column -->
                                   <ng-container matColumnDef="nombre">
                                     <th mat-header-cell *matHeaderCellDef> Nombre </th>
                                     <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="version">
                                     <th mat-header-cell *matHeaderCellDef> Versión </th>
                                     <td mat-cell *matCellDef="let element"> {{element.version}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="estructuraJerarquica">
                                     <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
                                     <td mat-cell *matCellDef="let element"> {{element.estructuraJerarquica?.nombre}} </td>
                                   </ng-container>


                                   <ng-container matColumnDef="creador">
                                     <th mat-header-cell *matHeaderCellDef> Creador </th>
                                     <td mat-cell *matCellDef="let element"> {{element.creador?.nombreCompleto}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="dueno">
                                     <th mat-header-cell *matHeaderCellDef> Dueño </th>
                                     <td mat-cell *matCellDef="let element"> {{element.owner?.nombreCompleto}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="fechaInicio">
                                     <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
                                     <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="fechaFin">
                                     <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
                                     <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="estado">
                                     <th mat-header-cell *matHeaderCellDef> Estado </th>
                                     <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
                                   </ng-container>

                                   <ng-container matColumnDef="action">
                                     <th mat-header-cell *matHeaderCellDef> Acción </th>
                                     <td mat-cell *matCellDef="let element" class="action-link">
                                       <a  [routerLink]="['/evaluacion',element.id]" target="_blank">Ver</a>
                                     </td>
                                   </ng-container>

                                   <tr mat-header-row *matHeaderRowDef="displayedColumnsEvaluaciones"></tr>
                                   <tr mat-row *matRowDef="let row; columns: displayedColumnsEvaluaciones;"></tr>
                                 </table>

                             </div>

                        </div>
                        <!-- / WIDGET GROUP -->

                    </mat-tab>


                </mat-tab-group>

            </div>
            <!-- TABS fin -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
